var map = {
	"./goods-1.png": "27de",
	"./goods-2.png": "081c",
	"./goods-3.png": "9f00",
	"./goods-4.png": "84be",
	"./goods-5.png": "c908",
	"./goods-6.png": "1a86",
	"./goods-7.png": "c538",
	"./goods-8.png": "6e08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1361";